
function valueCheck(functionName, value, expectedValue) {
  if (typeof value !== expectedValue) {
    throw new Error(`${functionName} function expected ${expectedValue} as one of its parameters.`);
  }
}

export function isCoinsubDomain() {
  return window.location.host.includes("coinsub.io");
}

export function countDecimals (value) {
  const inputValue = Number(value);
  valueCheck('countDecimals', inputValue, 'number');

  if (Math.floor(value) !== value) {
    return value.toString().split(".")[1].length || 0;
  }
  return 0;
}

/**
 * @param {String} url URL to normalize
 * @returns {String} normalized url
 */
export function normalizeURL(url) {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

/**
 * @param {Number} seconds Number of seconds to format
 * @returns {String} String of the format "5:30"
 */
export function formatTimer(seconds) {
  if (!seconds || seconds < 0 || typeof seconds !== 'number') {
    return "0:00";
  }

  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec.toString().padStart(2, '0')}`;
}

/**
 * @param {String} email Email to validate
 * @returns {Boolean} True if the email is valid, false otherwise
 */
export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * @param {String} address Ethereum address to validate
 * @returns {Boolean} True if the address is a valid Ethereum address, false otherwise
 */
export function validateEthereumAddress(address) {
  // Ethereum address regex: 0x followed by 40 hexadecimal characters
  const ethereumAddressRegex = /^0x[a-fA-F0-9]{40}$/;
  return ethereumAddressRegex.test(address);
}

/**
 * @param {String} address Wallet address to validate
 * @param {String} addressValidation Regex pattern from houdini_tokens table
 * @returns {Boolean} True if the address is valid, false otherwise
 */
export function validateWalletAddress(address, addressValidation) {
  if (!address || address.trim() === "") {
    return false;
  }

  if (!addressValidation || addressValidation.trim() === "") {
    return false;
  }

  const trimmedAddress = address.trim();

  try {
    const regex = new RegExp(addressValidation);
    return regex.test(trimmedAddress);
  } catch (error) {
    console.error("Invalid regex pattern from houdini_tokens:", addressValidation, error);
    return false;
  }
}

// Helper function to extract the root domain from a given domain
export function extractRootDomain(domain) {
  if (domain === "localhost") return domain;

  // Split by dots and take the last two parts for most cases
  const parts = domain.split(".");
  if (parts.length <= 2) return domain;

  // Handle special cases like .co.uk, .com.au etc.
  const specialTlds = ["co", "com", "org", "net", "edu", "gov"];
  if (parts.length === 3 && specialTlds.includes(parts[parts.length - 2])) {
    return parts.slice(-3).join(".");
  }

  return parts.slice(-2).join(".");
}

export async function getDomainData() {
  try {
    const response = await fetch("/verify/domain-data", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch domain data");
    }

    const data = await response.json();
    const domain = data.domain === "local" ? "localhost" : data.domain;
    const rootDomain = extractRootDomain(domain);

    debugLog("getDomainData:", data);
    return {
      ...data,
      domain: rootDomain,
    };
  } catch (error) {
    console.error("Error fetching domain data:", error);
  }
}

export function debounce(fn, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = undefined;
    }, timeout);
  };
}

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
         ('ontouchstart' in window) ||
         (navigator.maxTouchPoints > 0);
}

export function getViewportTier() {
  const w = Math.max(
    document.documentElement?.clientWidth || 0,
    window.innerWidth || 0
  )

  if (w > 0 && w < 768) return  "mobile" 
  if (w >= 768 && w < 1024) return "tablet"
  return  "desktop"
}

export { debugLog, debugError } from './debugLog';
